const BaseView = require('components-framework/view/base.view');
const trackingUtils = require('od-modules/utils/tracking.utils');

module.exports = BaseView.extend({
    name: 'ip_touchpoint',

    selectors: {
        container: '#ip-touchpoint',
        plusButton: 'ip_touchpoint_plus_button',
        linkButton: 'conditions_link',
        closeButton: 'ip_touchpoint_close_button',
    },

    events: {
        'tap': 'onTap',
    },

    TRACKINGS: {
        WIDGET_LOADED: 'hotel_upsell_widget_onload',
        TAPPED_ALL: 'hotel_upsell_widget_select_allwidget',
        TAPPED_PLUS: 'hotel_upsell_widget_select_plusbutton',
        TAPPED_CLOSE: 'hotel_upsell_widget_close',
    },

    initialize() {
        this.renderTemplate(`main`);
        this.handleSegmentSeparator();
    },

    renderTemplate(template, selector = this.$el, data = {}) {
        const {templates, keys} = this;
        if (Odigeo._.isFunction(templates[template])) {
            selector.html(templates[template](Odigeo._.extend(data, {
                keys: keys,
            })));
        }
        trackingUtils.trackEvent('upsell_widget', this.TRACKINGS.WIDGET_LOADED, Odigeo.History.getPageNameFromFragment());
    },

    render() {
        this.$el.html(this.templates.main(this.keys));
        $('.collapsible_segment_wrapper.od-collapsible-segment').first().addClass('od-collapsible-ip-touchpoint-modifier');
        trackingUtils.trackEvent('upsell_widget', this.TRACKINGS.WIDGET_LOADED, Odigeo.History.getPageNameFromFragment());
        return this;
    },

    onTap(e) {
        const {TAPPED_ALL, TAPPED_PLUS, TAPPED_CLOSE} = this.TRACKINGS;
        const tapped = e.target.classList;
        e.preventDefault();
        switch (true) {
            case tapped.contains(this.selectors.plusButton):
                this.sendTrackingEvent(TAPPED_PLUS);
                this.doTouchPointAction();
                break;
            case tapped.contains(this.selectors.closeButton):
                this.sendTrackingEvent(TAPPED_CLOSE);
                this.closeWidget();
                break;
            default:
                this.sendTrackingEvent(TAPPED_ALL);
                break;
        }
    },

    sendTrackingEvent(TRACKING_EVENT) {
        trackingUtils.trackEvent('upsell_widget', TRACKING_EVENT, Odigeo.History.getPageNameFromFragment());
    },

    doTouchPointAction() {
        Odigeo.Session.set('isIpTchpntHit', true);
        Odigeo.trigger(`${this.id}:ip-touchpoint-hit`);
    },

    closeWidget() {
        $(this.selectors.container).addClass('odf-hidden');
    },

    handleSegmentSeparator() {
        $('.collapsible_segment_wrapper.od-collapsible-segment').first().addClass('od-ip-touchpoint-separator-fix');
    },
});
